<template>
    <header :class="{'no-shadow': isIbeSticky}" class="viva-navbar transparent fixed seo-page-nav"
        v-click-outside="outside" ref="header">
        <template v-if="lang === 'es'">
            <div class="body">
                <div class="logo">
                    <a href="https://vivaaerobus.com/mx/"></a>
                </div>

                <div class="menu-content">
                    <a href="https://www.vivaaerobus.com/mx/mi-vuelo/" class="check-in-mobile-btn">
                        Mi vuelo
                    </a>

                    <nav class="links mobile-right">
                        <ul>
                            <!-- <li>
                                <a href="https://www.vivaaerobus.com/mx/viva-la-diversion/">Eventos</a>
                            </li> -->
                            <li>
                                <a href="https://www.vivaaerobus.com/mx/destinos/nuevas-rutas-para-ti">Destinos</a>
                            </li>
                            <li>
                                <a
                                    href="https://www.vivaaerobus.com/mx/promociones/promociones-de-vuelos">Promociones</a>
                            </li>
                            <li>
                                <a href="https://www.apps.vivaaerobus.com/VivaMonitor/">Estatus de vuelos</a>
                            </li>
                            <li>
                                <a href="https://www.vivaaerobus.com/mx/prepara-tu-vuelo/">Prepárate para volar</a>
                            </li>
                            <li>
                                <a href="https://www.vivaaerobus.com/mx/mi-vuelo-viva">Mi vuelo</a>
                            </li>
                        </ul>
                    </nav>
                    <nav class="user-links mobile-right">
                        <a class="trigger-mobile" @click="openMenuMobile()">
                            <span class="vi-menu-2"></span>
                        </a>
                        <ul>
                            <li>
                                <a href="https://www.vivaaerobus.com/mx/mi-vuelo/" class="important">
                                    Modifica tu reserva
                                </a>
                            </li>
                            <!-- <li>
                            <a class="trigger" @click="openLangMenu()">
                                {{currentLang.key}} <span class="vi-caret-down"></span>
                            </a>
                            <ul class="submenu" :class="{'active':showLangMenu}">
                                <template v-for="(item, index) in availableLangs">
                                    <li :class="{'active': item.key === currentLang.key}" :key="index">
                                        <a @click="setLang(item)">{{item.key}}</a>
                                    </li>
                                </template>
                            </ul>
                        </li>

                        <li>
                            <a class="trigger" @click="openCurrencyMenu()">
                                {{currentCurrency.code}} <span class="vi-caret-down"></span>
                            </a>
                            <ul class="submenu" :class="{'active':showCurrencyMenu}">
                                <template v-for="(item, index) in availableCurrency">
                                    <li :key="index">
                                        <a @click="setCurrency(item)">{{item.code}}</a>
                                    </li>
                                </template>
                            </ul>
                        </li> -->
                        </ul>
                    </nav>
                </div>


            </div>

            <div class="viva-menu-mobile" id="viva-header-vue" :class="{'active':showMenuMobile}">
                <div class="head">
                    <div class="logo">
                        <a href="https://www.vivaaerobus.com/"></a>
                    </div>
                    <div class="back" @click="showMenuMobile = false">
                        <span class="vi-bold-cancel"></span>
                    </div>
                </div>
                <div class="body">
                    <ul class="menu">
                        <!-- <li>
                            <div class="container">
                                <a href="https://www.vivaaerobus.com/mx/viva-la-diversion/">
                                    Eventos
                                </a>
                            </div>
                        </li> -->
                        <li>
                            <div class="container">
                                <a href="https://www.vivaaerobus.com/mx/destinos/nuevas-rutas-para-ti">
                                    Destinos
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="container">
                                <a href="https://www.vivaaerobus.com/mx/promociones/promociones-de-vuelos">
                                    Promociones
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="container">
                                <a href="https://apps.vivaaerobus.com/VivaMonitor/">
                                    Estatus de vuelos
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="container">
                                <a href="https://www.vivaaerobus.com/mx/prepara-tu-vuelo/">
                                    Prepárate para volar
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="container">
                                <a href="https://www.vivaaerobus.com/mx/mi-vuelo-viva">Modifica tu reserva</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="body">
                <div class="logo">
                    <a href="https://vivaaerobus.com/mx/"></a>
                </div>

                <div class="menu-content">
                    <a href="https://www.vivaaerobus.com/en/my-flight" class="check-in-mobile-btn">
                        Modify reservation
                    </a>

                    <nav class="links mobile-right">
                        <ul>
                            <li>
                                <a href="https://www.vivaaerobus.com/en/destinations">Destinations</a>
                            </li>
                            <li>
                                <a href="https://www.vivaaerobus.com/en/promotions">Promotions</a>
                            </li>
                            <li>
                                <a href="https://www.vivaaerobus.com/en/flight-status">Flight Status</a>
                            </li>
                            <li>
                                <a href="https://www.vivaaerobus.com/en/prepare-your-flight">Get ready to fly</a>
                            </li>
                            <li>
                                <a href="https://www.vivaaerobus.com/en/my-flight-viva">My Flight</a>
                            </li>
                        </ul>
                    </nav>
                    <nav class="user-links mobile-right">
                        <a class="trigger-mobile" @click="openMenuMobile()">
                            <span class="vi-menu-2"></span>
                        </a>
                        <ul>
                            <li>
                                <a href="https://www.vivaaerobus.com/en/my-flight" class="important">
                                    Modify reservation
                                </a>
                            </li>
                            <!-- <li>
                            <a class="trigger" @click="openLangMenu()">
                                {{currentLang.key}} <span class="vi-caret-down"></span>
                            </a>
                            <ul class="submenu" :class="{'active':showLangMenu}">
                                <template v-for="(item, index) in availableLangs">
                                    <li :class="{'active': item.key === currentLang.key}" :key="index">
                                        <a @click="setLang(item)">{{item.key}}</a>
                                    </li>
                                </template>
                            </ul>
                        </li>

                        <li>
                            <a class="trigger" @click="openCurrencyMenu()">
                                {{currentCurrency.code}} <span class="vi-caret-down"></span>
                            </a>
                            <ul class="submenu" :class="{'active':showCurrencyMenu}">
                                <template v-for="(item, index) in availableCurrency">
                                    <li :key="index">
                                        <a @click="setCurrency(item)">{{item.code}}</a>
                                    </li>
                                </template>
                            </ul>
                        </li> -->
                        </ul>
                    </nav>
                </div>


            </div>

            <div class="viva-menu-mobile" id="viva-header-vue" :class="{'active':showMenuMobile}">
                <div class="head">
                    <div class="logo">
                        <a href="https://www.vivaaerobus.com/"></a>
                    </div>
                    <div class="back" @click="showMenuMobile = false">
                        <span class="vi-bold-cancel"></span>
                    </div>
                </div>
                <div class="body">
                    <ul class="menu">
                        <li>
                            <div class="container">
                                <a href="https://www.vivaaerobus.com/en/destinations">Destinations</a>
                            </div>
                        </li>
                        <li>
                            <div class="container">
                                <a href="https://www.vivaaerobus.com/en/promotions">
                                    Promotions
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="container">
                                <a href="https://www.vivaaerobus.com/en/flight-status">
                                    Flight Status
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="container">
                                <a href="https://www.vivaaerobus.com/en/prepare-your-flight">
                                    Get ready to fly
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="container">
                                <a href="https://www.vivaaerobus.com/en/my-flight-viva">
                                    My Flight
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </template>

    </header>
</template>


<script>
import {
    mapGetters
} from 'vuex'

export default {
    data() {
        return {
            lang: "es",
            availableLangs: [{
                    name: "Español",
                    key: "ES"
                },
                {
                    name: "English",
                    key: "EN"
                }
            ],
            currentLang: null,
            availableCurrency: [{
                    code: "MXN",
                    name: {
                        "ES": "Pesos Mexicanos",
                        "EN": "Mexican Pesos"
                    }
                },
                {
                    code: "USD",
                    name: {
                        "ES": "Dólares Americanos",
                        "EN": "Dollar"
                    }
                }
            ],
            currentCurrency: null,
            flightCriteria: null,
            showLangMenu: false,
            showCurrencyMenu: false,
            showMenuMobile: false
        }
    },
    computed: {
        ...mapGetters(['headerHeight','isIbeSticky'])
    },
    methods: {
        openLangMenu: function () {
            this.showLangMenu = !this.showLangMenu;
            this.showCurrencyMenu = false;
        },
        openCurrencyMenu: function () {
            this.showCurrencyMenu = !this.showCurrencyMenu;
            this.showLangMenu = false;
        },
        setLang: function (data) {
            this.currentLang = data;
            //set cookie
            if (this.currentLang.key === "ES") {
                this.$cookies.set('LanguageCookie', 'mx', {
                    expires: '1Y'
                });
            } else {
                this.$cookies.set('LanguageCookie', 'en', {
                    expires: '1Y'
                });
            }
            this.closeAll();
        },
        setCurrency: function (data) {
            this.closeAll();
            this.currentCurrency = data;
            if (this.flightCriteria) {
                this.flightCriteria.Currency = this.currentCurrency.code;
                //set cookie currency
                this.$cookies.set('FlightSearchCriteria_https', JSON.stringify(this.flightCriteria), {
                    expires: '1Y'
                });
            }
        },
        closeAll: function () {
            this.showLangMenu = false;
            this.showCurrencyMenu = false;
        },
        openMenuMobile: function () {
            this.showMenuMobile = !this.showMenuMobile;
        },
        toggleHamburgerMenu() {
            this.showHamburgerMenu = !this.showHamburgerMenu
        },
        onBodyScroll() {
            // this.headerScrollClass = (window.scrollY > 5);
            this.$store.commit('updateIsIbeFixed', (window.scrollY > this.headerHeight));
        },
        headerHeightUpdate() {
            //this is to get header height
            if (this.$refs.header) {
                this.$store.commit('updateHeaderHeight', this.$refs.header.clientHeight)
            }
        },
        outside: function (e) {
            // this.clickOutside += 1
            // console.log('clicked outside!');
            this.closeAll();
        }
    },
    beforeMount: function () {
        //console.group('nav bar beforeMount');

        //lang
        let defaultLang = "ES";
        if (this.$cookies.isKey('LanguageCookie')) {
            if (this.$cookies.get('LanguageCookie') !== 'mx') {
                defaultLang = "EN";
            }
        }

        let langData = this.availableLangs.filter((el) => {
            return (el.key === defaultLang);
        });

        if (langData.length > 0) {
            this.currentLang = langData[0];
        }
        //lang

        //currency
        let defaultCurrency = "MXN";
        if (this.$cookies.isKey('FlightSearchCriteria_https')) {
            //console.log('CRITERIA');
            this.flightCriteria = this.$cookies.get('FlightSearchCriteria_https');
            defaultCurrency = this.flightCriteria.Currency;
        }

        let currencyData = this.availableCurrency.filter((el) => {
            return (el.code === defaultCurrency);
        });

        if (currencyData.length > 0) {
            this.currentCurrency = currencyData[0];
        }

        //currency


        //console.groupEnd();
    },
    mounted() {
        this.headerHeightUpdate();
        window.addEventListener('scroll', (e) => {
            setTimeout(() => {
                this.onBodyScroll();
            }, 100);
            this.headerHeightUpdate();
        });
        window.addEventListener('resize', (e) => {
            setTimeout(() => {
                this.headerHeightUpdate();
            }, 100);
        });



        let uri = window.location.href.split('?');

        // url variables
        if(/\/en\//.test(uri)){
            this.lang = 'en';
        }

        if (uri.length == 2) {
            let vars = uri[1].split('&');
            let getVars = {};
            let tmp = '';
            vars.forEach(function (v) {
                tmp = v.split('=');
                if (tmp.length == 2)
                    getVars[tmp[0]] = tmp[1];
            });
            if(typeof getVars.lang !== 'undefined'){
                this.lang = getVars.lang;
            }
        }
        // url variables

    },
    directives: {
        'click-outside': {
            bind: function (el, binding, vNode) {
                // Provided expression must evaluate to a function.
                if (typeof binding.value !== 'function') {
                    const compName = vNode.context.name
                    let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
                    if (compName) {
                        warn += `Found in component '${compName}'`
                    }

                    console.warn(warn)
                }
                // Define Handler and cache it on the element
                const bubble = binding.modifiers.bubble
                const handler = (e) => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler

                // add Event Listeners
                document.addEventListener('click', handler)
            },

            unbind: function (el, binding) {
                // Remove Event Listeners
                document.removeEventListener('click', el.__vueClickOutside__)
                el.__vueClickOutside__ = null

            }
        }
    }
}
</script>